import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';
import { formatDate } from "../../utils";

const dateHelp = (content, title) => React.createElement(
    Tooltip,
    { title },
    React.createElement('span', null, content)
);

const deadlineHelp = (content) => dateHelp(content, "The estimated date for the delivery to be completed.");

export const ongoingProject = [
    {
        title: 'Project Id',
        dataIndex: 'id',
        key: 'id',
        // render : (id) => id
    },
    {
        title: 'Item',
        dataIndex: 'product',
        key: 'name',
        render : (product) => product?.name

    },
    {
        title: 'Approved Quantity',
        dataIndex: 'approved_quantity',
        key: 'approved_quantity',
    },
    {
        title: dateHelp(React.createElement(React.Fragment, null, 'Request Date ', React.createElement(InfoCircleOutlined)), "The date the production request was created."),
        // dataIndex: 'item_statuses',
        // key: 'item_statuses',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render : (createdAt) => dateHelp(formatDate(createdAt), "The date the production request was created.")
    },
    {
        title: deadlineHelp(React.createElement(React.Fragment, null, 'Deadline Delivery ', React.createElement(InfoCircleOutlined))),
        dataIndex: 'client_expected_delivery_date',
        key: 'deadline',
        render : (client_expected_delivery_date) => deadlineHelp(formatDate(client_expected_delivery_date))

    },
];


